import createApi from "../utils/axiosInstance";

export const addNewTraining = async (data) => {
  try {
    const api = createApi(true);
    const response = await api.post(`/admin/training/create-training`, data);
    return response.data;
  } catch (error) {
    console.error(
      "New training data addition failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const getTrainingData = async (page, limit, search, level) => {
  try {
    const api = createApi(true);
    const response = await api.get(
      `/admin/training/training-by-level/${level}?page=${page}&limit=${limit}&search=${search}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Get training data failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const getAllCoachesData = async () => {
  try {
    const api = createApi(true);
    const response = await api.get(`/auth/admin/get-all-partners`);
    return response.data;
  } catch (error) {
    console.error(
      "Get training data failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const getAllLevels = async (userId) => {
  try {
    const api = createApi(true);
    const response = await api.get(`/admin/training/get-level/${userId || ""}`);
    return response.data;
  } catch (error) {
    console.error(
      "Get training data failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const updateTraining = async (trainingData, levelId, trainingId) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/admin/training/edit-training-levels/${trainingId}/${levelId}`,
      trainingData
    );
    return response.data;
  } catch (error) {
    console.error(
      "Update  failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const updateCommunityLink = async (link, levelName, userId) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/admin/training/edit-level-link/${userId ? userId : ""}`,
      { link, levelName }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Update  failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const updateFAQforLevel = async (faq, levelName, userId) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/admin/training/edit-level-faq/${userId ? userId : ""}`,
      { faq, levelName }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Update  failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const deleteTraining = async (trainingId) => {
  try {
    const api = createApi(true);
    const response = await api.delete(
      `/admin/training/delete-training/${trainingId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Delete training failed:",
      error.response ? error.response.data : error.message
    );
    throw error.response ? error.response.data : error;
  }
};

export const createMasterclassApi = async (masterclassData) => {
  try {
    const api = createApi(true);
    const response = await api.post(
      `/admin/masterclass/create-masterclass`,
      masterclassData
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error creating masterclass:",
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export const getAllMasterclassesApi = async (params = {}) => {
  try {
    const api = createApi(true);
    const response = await api.get(`/admin/masterclass/masterclasses`, {
      params
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching masterclasses:",
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export const getMasterclassByIdApi = async (id) => {
  try {
    const api = createApi(true);
    const response = await api.get(`/admin/masterclass/masterclass/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching masterclass:",
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export const updateMasterclassApi = async (id, updateData) => {
  try {
    const api = createApi(true);
    const response = await api.put(
      `/admin/masterclass/masterclass/${id}`,
      updateData
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating masterclass:",
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export const deleteMasterclassApi = async (id) => {
  try {
    const api = createApi(true);
    const response = await api.delete(`/admin/masterclass/masterclass/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting masterclass:",
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export const updateCommunityLinkForMasterclassApi = async (id, level, link) => {
  try {
    const api = createApi(true);
    const response = await api.put(
      `/admin/masterclass/masterclass/${id}/community-link`,
      {
        level,
        link
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating community link:",
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

export const createMasterclassTrainingApi = async (trainingData) => {
  const api = createApi(true);
  const response = await api.post(
    "/admin/masterclass/masterclass-trainings",
    trainingData
  );
  return response.data;
};

export const getAllMasterclassTrainingsApi = async (params) => {
  const api = createApi(true);
  const response = await api.get("/admin/masterclass/masterclass-trainings", {
    params
  });
  return response.data;
};
export const getAllSharedMasterclassTrainingsApi = async (params) => {
  const api = createApi(true);
  const response = await api.get("/admin/masterclass/shared-masterclass-trainings", {
    params
  });
  return response.data;
};

export const updateMasterclassTrainingApi = async (id, updateData) => {
  const api = createApi(true);
  const response = await api.put(
    `/admin/masterclass/masterclass-trainings/${id}`,
    updateData
  );
  return response.data;
};

export const deleteMasterclassTrainingApi = async (id) => {
  const api = createApi(true);
  const response = await api.delete(
    `/admin/masterclass/masterclass-trainings/${id}`
  );
  return response.data;
};
